import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Steps,
  Form,
  Button,
  Col,
  Row,
  Spin,
  Card,
  Typography,
  Flex,
} from "antd";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { useForm } from "antd/lib/form/Form";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import appStatic from "../../../../config/appStatic";
import appLabel from "../../../../config/appLabel";
import DetailsForm from "../components/DetailsForm";
import CurrencyForm from "../components/CurrencyForm";
import TermsForm from "../components/TermsForm";
import SettingsForm from "../components/SettingsForm";
import AccountingForm from "../components/AccountingForm";
import ChargesForm from "../components/ChargesForm";
import InterestRateChart from "../components/InterestRateChart";
import Preview from "../components/Preview";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import styles from "../../../../assets/styles/styles";
import dayjs from "dayjs";
import { labelConfig } from "../../../customer/customer.config";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Title, Text } = Typography;

const NewPRD0300 = (props) => {
  //DECLARED VARIABLES
  const navigate = useNavigate();
  const { userData } = props;
  const [chargesOptions, setChargesOptions] = useState([]);
  const { session } = userData;
  const [form] = useForm();
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [showAdvancedAccounting, setShowAdvancedAccounting] = useState(false);
  const [interestRateTableSource, setInterestRateTableSource] = useState([]);
  const [current, setCurrent] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [
    interestCompoundingPeriodTypeOptions,
    setInterestCompoundingPeriodTypeOptions,
  ] = useState([]);
  const [
    interestPostingPeriodTypeOptions,
    setInterestPostingPeriodTypeOptions,
  ] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] =
    useState([]);
  const [
    interestCalculationDaysInYearTypeOptions,
    setInterestCalculationDaysInYearTypeOptions,
  ] = useState([]);
  const [
    lockinPeriodFrequencyTypeOptions,
    setLockinPeriodFrequencyTypeOptions,
  ] = useState([]);
  const [minDepositTypeOptions, setMinDepositTypeOptions] = useState([]);
  const [maxDepositTypeOptions, setMaxDepositTypeOptions] = useState([]);
  const [
    inMultiplesOfDepositTermTypeOptions,
    setInMultiplesOfDepositTermTypeOptions,
  ] = useState([]);
  const [
    preClosurePenalInterestOnTypeOptions,
    setPreClosurePenalInterestOnTypeOptions,
  ] = useState([]);
  const [taxGroupOptions, setTaxGroupOptions] = useState([]);
  const [periodTypeOptions, setPeriodTypeOptions] = useState([]);
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [expenseAccountOptions, setExpenseAccountOptions] = useState([]);
  const [liabilityAccountOptions, setLiabilityAccountOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [chargeOptions, setChargeOptions] = useState([]);
  const [penaltyOptions, setPenaltyOptions] = useState([]);
  const [accountingRuleOptions, setAccountingRuleOptions] = useState([]);
  const [conditionTypeOptions, setConditionTypeOptions] = useState([]);
  const [attributeNameOptions, setAttributeNameOptions] = useState([]);
  const [incentiveTypeOptions, setIncentiveTypeOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [clientClassificationOptions, setClientClassificationOptions] =
    useState([]);
  const [currency, setCurrency] = useState(null);
  const [clientTypeOptions, setClientTypeOptions] = useState([]);
  const [tempChargeOptions, setTempChargeOptions] = useState([]);
  const [fixedDepositDetails, setFixedDepositDetails] = useState({});
  const [withdoldTax, setWithdoldTax] = useState(false);
  const [isPrimaryGroupingByAmount, setIsPrimaryGroupingByAmnt] =
    useState(false);
  const [formData, setFormData] = useState({
    details: null,
    currency: null,
    terms: null,
    settings: null,
    interestRateChart: null,
    charges: null,
    accountingRule: "2",
  });

  useEffect(() => {
    getTemplate();
  }, []);

  function onCancel() {
    navigate("/prd0200", { replace: false });
  }
  function getTemplate() {
    let body = {
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.GetFixedDepositTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        setFixedDepositDetails(res);
        const objList = res;
        // console.log(res);

        let tempCurrency = [];
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempMinDepositTypeOptions = [];
        let tempMaxDepositTypeOptions = [];
        let tempInMultiplesOfDepositTermTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempPeriodTypeOptions = [];
        let tempAssetAccountOptions = [];
        let tempIncomeAccountOptions = [];
        let tempExpenseAccountOptions = [];
        let tempLiabilityAccountOptions = [];
        let tempPaymentTypeOptions = [];
        let tempChargeOptions = [];
        let tempPenaltyOptions = [];
        let tempAccountingRuleOptions = [];
        let tempAttributeNameOptions = [];
        let tempConditionTypeOptions = [];
        let tempIncentiveTypeOptions = [];
        let tempGenderOptions = [];
        let tempClientClassificationOptions = [];
        let tempClientTypeOptions = [];
        let tempChargesOptions = [];
        let tempCharges = [];

        form.setFieldsValue({
          currencyCode: objList?.currencyOptions[0]?.code,
          digitsAfterDecimal: objList?.currencyOptions[0]?.decimalPlaces,
          preClosurePenalApplicable: false,
          withHoldTax: false,
          fromDate: dayjs(),
          isPrimaryGroupingByAmount: false,
          interestCompoundingPeriodType:
            objList?.interestCompoundingPeriodTypeOptions[0]?.id,
          interestPostingPeriodType:
            objList?.interestPostingPeriodTypeOptions[0]?.id,
          interestCalculationType:
            objList?.interestCalculationTypeOptions[0]?.id,
          interestCalculationDaysInYearType:
            objList?.interestCalculationDaysInYearTypeOptions[0]?.id,
        });

        objList?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestCalculationDaysInYearTypeOptions?.forEach(
          (element) => {
            tempInterestCalculationDaysInYearTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempMinDepositTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempMaxDepositTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempInMultiplesOfDepositTermTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          }
        );

        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          }
        );

        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          }
        );

        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          }
        );

        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.accountingRuleOptions?.forEach((element) => {
          tempAccountingRuleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.chartTemplate?.attributeNameOptions?.forEach((element) => {
          tempAttributeNameOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.chartTemplate?.conditionTypeOptions?.forEach((element) => {
          tempConditionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.chartTemplate?.incentiveTypeOptions?.forEach((element) => {
          tempIncentiveTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.chartTemplate?.genderOptions?.forEach((element) => {
          tempGenderOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.chartTemplate?.clientClassificationOptions?.forEach(
          (element) => {
            tempClientClassificationOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.chartTemplate?.clientTypeOptions?.forEach((element) => {
          tempClientTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        setCurrency(objList?.currencyOptions[0]?.code);
        setCurrencyOptions(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(
          tempInterestCompoundingPeriodTypeOptions
        );
        setInterestPostingPeriodTypeOptions(
          tempInterestPostingPeriodTypeOptions
        );
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(
          tempInterestCalculationDaysInYearTypeOptions
        );
        setLockinPeriodFrequencyTypeOptions(
          tempLockinPeriodFrequencyTypeOptions
        );
        setMinDepositTypeOptions(tempMinDepositTypeOptions);
        setMaxDepositTypeOptions(tempMaxDepositTypeOptions);
        setInMultiplesOfDepositTermTypeOptions(
          tempInMultiplesOfDepositTermTypeOptions
        );
        setPreClosurePenalInterestOnTypeOptions(
          tempPreClosurePenalInterestOnTypeOptions
        );
        setTaxGroupOptions(tempTaxGroupOptions);
        setPeriodTypeOptions(tempPeriodTypeOptions);
        setAssetAccountOptions(tempAssetAccountOptions);
        setIncomeAccountOptions(tempIncomeAccountOptions);
        setExpenseAccountOptions(tempExpenseAccountOptions);
        setLiabilityAccountOptions(tempLiabilityAccountOptions);
        setPaymentTypeOptions(tempPaymentTypeOptions);
        setPenaltyOptions(tempPenaltyOptions);
        setAccountingRuleOptions(tempAccountingRuleOptions);
        setConditionTypeOptions(tempConditionTypeOptions);
        setAttributeNameOptions(tempAttributeNameOptions);
        setIncentiveTypeOptions(tempIncentiveTypeOptions);
        setGenderOptions(tempGenderOptions);
        setClientClassificationOptions(tempClientClassificationOptions);
        setClientTypeOptions(tempClientTypeOptions);
        setTempChargeOptions(objList?.chargeOptions);

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });

          const chargeForTableData = tempChargesOptions.filter(
            (item) => item.currencyCode === tempCurrency[0].value
          );

          setChargeTableSource(tempCharges);
          setChargesOptions([...chargeForTableData]);
        });

        setIsLoading(false);
      }
    });
  }
  const onChange = (value) => {
    setCurrent(value);
  };
  const onFinishDetailsForm = (values) => {
    // console.log(fixedDepositDetails);
    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };
  const onFinishCurrencyForm = (values) => {
    values.digitsAfterDecimal = parseInt(values.digitsAfterDecimal);
    setFormData({ ...formData, currency: values });
    // console.log(values);

    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    const stringifiedValues = {
      ...values,
      depositAmount:
        values.depositAmount != null ? String(values.depositAmount) : undefined,
      minDepositAmount:
        values.minDepositAmount != null
          ? String(values.minDepositAmount)
          : undefined,
      maxDepositAmount:
        values.maxDepositAmount != null
          ? String(values.maxDepositAmount)
          : undefined,
    };

    setFormData({ ...formData, terms: stringifiedValues });

    setCurrent(current + 1);
  };
  const onFinishSettingsForm = (values) => {
    setFormData({ ...formData, settings: values });
    setCurrent(current + 1);
    // console.log(values);
  };

  const onFinishInterestRateChart = (values) => {
    // console.log(values);
    const cleanValue = (val) => {
      if (val === null || val === undefined || val === "") return undefined;
      const stripped = typeof val === "string" ? val.replace(/,/g, "") : val;
      return String(stripped);
    };

    const chartSlabs = interestRateTableSource.map((element) => {
      const slab = {
        description: element.description,
        periodType: fixedDepositDetails?.periodFrequencyTypeOptions.find(
          (item) => item.value === element.periodType
        )?.id,
        locale: "en",
        incentives: [],
      };

      // Add only if value exists
      const optionalFields = {
        amountRangeFrom: cleanValue(element.amountRangeFrom),
        amountRangeTo: cleanValue(element.amountRangeTo),
        fromPeriod: cleanValue(element.fromPeriod),
        toPeriod: cleanValue(element.toPeriod),
        annualInterestRate: cleanValue(element.annualInterestRate),
      };

      Object.entries(optionalFields).forEach(([key, value]) => {
        if (value !== undefined) {
          slab[key] = value;
        }
      });

      return slab;
    });

    const charts = [
      {
        fromDate: BOM.DateTime(values.fromDate, "only-date"),
        dateFormat: "dd MMMM yyyy",
        locale: "en",
        isPrimaryGroupingByAmount: values.isPrimaryGroupingByAmount,
        enableManualInterestEntry: values.enableManualInterestEntry,
        minimumManualInterestAmount: values.minimumManualInterestAmount,
        maximumManualInterestAmount: values.maximumManualInterestAmount,
        chartSlabs,
      },
    ];

    values.charts = charts;
    delete values.id;
    delete values.enableManualInterestEntry;
    delete values.minimumManualInterestAmount;
    delete values.maximumManualInterestAmount;

    setFormData({ ...formData, interestRateChart: values });
    setCurrent(current + 1);

    console.log(values);
  };

  const onFinishChargeForm = (values) => {
    let tempChargeArray = [];
    chargeTableSource.forEach((element, index) => {
      tempChargeArray.push({
        id: element.id,
      });
    });

    values.charges = tempChargeArray;

    delete values.id;

    setFormData({ ...formData, charges: values });
    // console.log(values);

    setCurrent(current + 1);
  };

  const onFinishAccountingForm = (values) => {
    const cleanedValues = {
      ...values,
      accountingRule: "2",
      feeToIncomeAccountMappings:
        values.configureFundOptions && values.fundSourceAccountId
          ? [
              {
                chargeId: values.configureFundOptions,
                incomeAccountId: values.fundSourceAccountId,
              },
            ]
          : [],
      paymentChannelToFundSourceMappings:
        values.chargeId && values.incomeAccountId
          ? [
              {
                fundSourceAccountId: values.chargeId,
                paymentTypeId: values.incomeAccountId,
              },
            ]
          : [],
      penaltyToIncomeAccountMappings:
        values.penaltySpecificIncomeaccounts &&
        values.penaltySpecificIncomeaccount
          ? [
              {
                chargeId: values.penaltySpecificIncomeaccounts,
                incomeAccountId: values.penaltySpecificIncomeaccount,
              },
            ]
          : [],
    };

    setFormData({ ...formData, accounting: cleanedValues });
    setCurrent(current + 1);

    // console.log(cleanedValues);
  };

  const onChangeCurrency = (value) => {
    const selectedCurrency = value;
    let tempChargesOptions = [];
    let tempCharges = [];
    // console.log(selectedCurrency);
    setCurrency(selectedCurrency);

    fixedDepositDetails?.chargeOptions?.forEach((element) => {
      tempChargesOptions.push({
        value: element.id,
        label: `${element.name}(${element?.currency?.name})`,
        currencyName: element?.currency?.name,
        currencyCode: element?.currency?.code,
      });
    });

    const chargeForTableData = tempChargesOptions.filter(
      (item) => item.currencyCode === selectedCurrency
    );

    setChargeTableSource(tempCharges);
    setChargesOptions([...chargeForTableData]);

    form.setFieldsValue({
      // Reset all accounting-related fields
      savingsReferenceAccountId: undefined,
      savingsControlAccountId: undefined,
      transfersInSuspenseAccountId: undefined,
      interestOnSavingsAccountId: undefined,
      incomeFromFeeAccountId: undefined,
      incomeFromPenaltyAccountId: undefined,
      // Reset advanced accounting fields if they exist
      configureFundOptions: undefined,
      fundSourceAccountId: undefined,
      chargeId: undefined,
      incomeAccountId: undefined,
      penaltySpecificIncomeaccounts: undefined,
      penaltySpecificIncomeaccount: undefined,
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      accounting: null,
    }));
  };

  const filteredAssetAccounts = assetAccountOptions.filter(
    (item) => item.currency === currency
  );

  const filteredIncomeAccounts = incomeAccountOptions.filter(
    (item) => item.currency === currency
  );
  const filteredexpenseAccountOptions = expenseAccountOptions.filter(
    (item) => item.currency === currency
  );
  const filteredLiabilityAccountOptions = liabilityAccountOptions.filter(
    (item) => item.currency === currency
  );

  const handleWitholdTaxChange = () => {
    setWithdoldTax(!withdoldTax);
  };
  const forms = [
    <DetailsForm
      onFinish={onFinishDetailsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.details}
      form={form}
    />,
    <CurrencyForm
      onFinish={onFinishCurrencyForm}
      current={current}
      onChangeCurrency={onChangeCurrency}
      setCurrent={setCurrent}
      initialValues={formData.currency}
      form={form}
      currencyOptions={currencyOptions}
      tempChargeOptions={tempChargeOptions}
      setChargeOptions={setChargeOptions}
    />,
    <TermsForm
      onFinish={onFinishTermsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.terms}
      form={form}
      interestCompoundingPeriodTypeOptions={
        interestCompoundingPeriodTypeOptions
      }
      interestPostingPeriodTypeOptions={interestPostingPeriodTypeOptions}
      interestCalculationTypeOptions={interestCalculationTypeOptions}
      interestCalculationDaysInYearTypeOptions={
        interestCalculationDaysInYearTypeOptions
      }
    />,
    <SettingsForm
      onFinish={onFinishSettingsForm}
      current={current}
      withdoldTax={withdoldTax}
      handleWitholdTaxChange={handleWitholdTaxChange}
      setCurrent={setCurrent}
      initialValues={formData.settings}
      form={form}
      lockinPeriodFrequencyTypeOptions={lockinPeriodFrequencyTypeOptions}
      minDepositTypeOptions={minDepositTypeOptions}
      maxDepositTypeOptions={maxDepositTypeOptions}
      inMultiplesOfDepositTermTypeOptions={inMultiplesOfDepositTermTypeOptions}
      preClosurePenalInterestOnTypeOptions={
        preClosurePenalInterestOnTypeOptions
      }
      taxGroupOptions={taxGroupOptions}
    />,
    <InterestRateChart
      onFinish={onFinishInterestRateChart}
      current={current}
      interestRateTableSource={interestRateTableSource}
      setInterestRateTableSource={setInterestRateTableSource}
      userData={userData}
      isPrimaryGroupingByAmount={isPrimaryGroupingByAmount}
      setIsPrimaryGroupingByAmnt={setIsPrimaryGroupingByAmnt}
      setCurrent={setCurrent}
      initialValues={formData.settings}
      form={form}
      periodTypeOptions={periodTypeOptions}
      conditionTypeOptions={conditionTypeOptions}
      attributeNameOptions={attributeNameOptions}
      incentiveTypeOptions={incentiveTypeOptions}
      genderOptions={genderOptions}
      clientTypeOptions={clientTypeOptions}
      clientClassificationOptions={clientClassificationOptions}
    />,
    <ChargesForm
      onFinish={onFinishChargeForm}
      userData={userData}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      chargesOptions={chargesOptions}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.charges}
      form={form}
      chargeOptions={chargeOptions}
    />,
    <AccountingForm
      onFinish={onFinishAccountingForm}
      current={current}
      showAdvancedAccounting={showAdvancedAccounting}
      setShowAdvancedAccounting={setShowAdvancedAccounting}
      setCurrent={setCurrent}
      initialValues={formData.account}
      form={form}
      accountingRuleOptions={accountingRuleOptions}
      assetAccountOptions={filteredAssetAccounts}
      incomeAccountOptions={filteredIncomeAccounts}
      expenseAccountOptions={filteredexpenseAccountOptions}
      liabilityAccountOptions={filteredLiabilityAccountOptions}
      paymentTypeOptions={paymentTypeOptions}
      chargesOptions={chargesOptions}
      penaltyOptions={penaltyOptions}
    />,
    <Preview
      formData={formData}
      fixedDepositDetails={fixedDepositDetails}
      setFixedDepositDetails={setFixedDepositDetails}
      chargeTableSource={chargeTableSource}
      lockinPeriodFrequencyTypeOptions={lockinPeriodFrequencyTypeOptions}
      showAdvancedAccounting={showAdvancedAccounting}
      setShowAdvancedAccounting={setShowAdvancedAccounting}
    />,
  ];

  const isLastStep = current === forms.length - 1;
  const interestRateStep = current === forms.length - 4;

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/prd0300", { replace: false });
  }

  const onSubmit = () => {
    let formValues = {
      ...formData.details,
      ...formData.currency,
      ...formData.terms,
      ...formData.settings,
      ...formData.interestRateChart,
      ...formData.charges,
      ...formData.accounting,
    };

    delete formValues.annualInterestRate;
    delete formValues.fromDate;
    delete formValues.endDate;
    delete formValues.periodType;
    delete formValues.fromPeriod;
    delete formValues.toPeriod;
    delete formValues.amountRangeFrom;
    delete formValues.amountRangeTo;
    delete formValues.configureFundOptions;
    delete formValues.fundSourceAccountId;
    delete formValues.chargeId;
    delete formValues.incomeAccountId;
    delete formValues.penaltySpecificIncomeaccounts;
    delete formValues.penaltySpecificIncomeaccount;
    delete formValues.attributename;
    delete formValues.conditionType;
    delete formValues.incentiveType;
    delete formValues.amount;
    delete formValues.attributeValueclienttype;
    delete formValues.isPrimaryGroupingByAmount;

    // delete formValues.preClosurePenalApplicable;
    // delete formValues.withHoldTax;
    // delete formValues.preClosurePenalInterest;

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewFixedDeposit,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newFixedDepositMsg);
          navigate("/prd0300");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd0300");
          setIsLoading(false);
        },
      }
    );
  };

  const steps = [
    "details",
    "currency",
    "terms",
    "settings",
    "interestRateChart",
    "charges",
    "accounting",
    "preview",
  ];

  return (
    <MainLayout isEnableRightSidebar={false} currentStep={steps[current]}>
      <TopContent
        pageTitle={appLabel.newFixedDeposit}
        pageItems={appStatic.NewFixedDepositItems}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={labelConfig.productSetup} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                {/*Interractive Section */}

                <Row style={{ justifyContent: "space-between" }}>
                  {/* Navigation section */}
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={onChange}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>Details</Text>,
                        },
                        {
                          title: <Text strong>Currency</Text>,
                        },
                        {
                          title: <Text strong>Terms</Text>,
                        },
                        {
                          title: <Text strong>Settings</Text>,
                        },
                        {
                          title: <Text strong>Interest Rate Chart</Text>,
                        },
                        {
                          title: <Text strong>Charges</Text>,
                        },
                        {
                          title: <Text strong>Accounting</Text>,
                        },
                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                    {/* </Form> */}
                  </Card>
                </Row>
              </Col>
              {/* Description Section */}
            </Row>

            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "10px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "10%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    colortext="black"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      backgroundColor: "#92428B",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    Prev
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      backgroundColor: "#92428B",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    Next
                  </Button>
                )}
                {BOM.HasPermission("CREATE_FIXEDDEPOSITPRODUCT") &&
                  isLastStep && (
                    <Button
                      style={{
                        width: "10%",
                        backgroundColor: "white",
                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                      }}
                      onClick={onSubmit}
                    >
                      Submit
                    </Button>
                  )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NewPRD0300);
